export enum TicketStatusesEnum {
  REQUESTED = 1,
  ACCEPTED = 2,
  REJECTED = 3,
  PLACED = 4,
  STORNED = 6,
  FAILED = 7,
  PASSED = 8,
  PAYED = 9,
  OUTDATED = 10,
  PRINTED = 11,
  PULLED = 12,
  CASHBACK = 13,
  CANCELED = 14,
  PAYED_CASHBACK = 15,
  PAYED_TURBO = 16,
  GIVE_UP = 17,
  EXPIRED = 19,
  PAYED_CASHOUT = 20,
  RISK_CASHOUT = 23,
  PASSED_CASHOUT = 24,
  REJECTED_BY_RISK = 52,
}

export enum BingoTicketStatusesEnum {
  PLACED = 4,
  CANCELED = 14,
  FAILED = 7,
  PASSED = 8,
  PAYED = 9,
  PULLED = 12,
  ACCEPTED = 2,
  PRINTED = 11,
}

export enum TransactionTypeEnum {
  DEPOSIT = 2,
  WITHDRAWAL = 22,
}
